import api from './api';
import { GroomingAppointment, GroomingServiceType, GroomingStatus, GroomingCompleteResponse } from '@/types';

export interface GroomingAppointmentCreate {
  patient_id: number;
  scheduled_date: string;
  scheduled_time: string;
  duration_minutes?: number;
  service_type?: GroomingServiceType;
  notes?: string;
}

export interface GroomingAppointmentUpdate {
  scheduled_date?: string;
  scheduled_time?: string;
  duration_minutes?: number;
  service_type?: GroomingServiceType;
  status?: GroomingStatus;
  notes?: string;
}

export interface GroomingFilters {
  date_from?: string;
  date_to?: string;
  status?: GroomingStatus;
  patient_id?: number;
  skip?: number;
  limit?: number;
}

export const groomingService = {
  async getAppointments(filters?: GroomingFilters): Promise<GroomingAppointment[]> {
    const response = await api.get<GroomingAppointment[]>('/grooming', { params: filters });
    return response.data;
  },

  async getCalendar(dateFrom: string, dateTo: string): Promise<GroomingAppointment[]> {
    const response = await api.get<GroomingAppointment[]>('/grooming/calendar', {
      params: { date_from: dateFrom, date_to: dateTo },
    });
    return response.data;
  },

  async getAppointment(id: number): Promise<GroomingAppointment> {
    const response = await api.get<GroomingAppointment>(`/grooming/${id}`);
    return response.data;
  },

  async createAppointment(data: GroomingAppointmentCreate): Promise<GroomingAppointment> {
    const response = await api.post<GroomingAppointment>('/grooming', data);
    return response.data;
  },

  async updateAppointment(id: number, data: GroomingAppointmentUpdate): Promise<GroomingAppointment> {
    const response = await api.put<GroomingAppointment>(`/grooming/${id}`, data);
    return response.data;
  },

  async completeAppointment(id: number): Promise<GroomingCompleteResponse> {
    const response = await api.post<GroomingCompleteResponse>(`/grooming/${id}/complete`);
    return response.data;
  },

  async cancelAppointment(id: number): Promise<GroomingAppointment> {
    const response = await api.post<GroomingAppointment>(`/grooming/${id}/cancel`);
    return response.data;
  },

  async deleteAppointment(id: number): Promise<void> {
    await api.delete(`/grooming/${id}`);
  },
};

// Labels para UI
export const SERVICE_TYPE_LABELS: Record<GroomingServiceType, string> = {
  bath: 'Baño',
  haircut: 'Corte',
  bath_haircut: 'Baño + Corte',
  other: 'Otro',
};

export const STATUS_LABELS: Record<GroomingStatus, string> = {
  pending: 'Pendiente',
  completed: 'Completado',
  cancelled: 'Cancelado',
};

export const STATUS_COLORS: Record<GroomingStatus, string> = {
  pending: 'bg-yellow-100 text-yellow-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};
